<div class="product-wrapper comman-wrap" *ngIf="selectedItem">
  <ng-container>
    <app-header></app-header>
  </ng-container>
  <ng-container>
    <app-breadcrumb-nav [breadCrumbData]="breadCrumbData" [menuData]="menuListData" [storeDetails]="storeDetails">
    </app-breadcrumb-nav>
  </ng-container>
  <div class="product-slider">
    <div class="top-full-width-slider">
      <app-product-detail [item]="selectedItem" [noOfpannel]="noOfpannel" [itemType]="itemType"
        [isPanelOpened]="panelOpenState" [isPanelOpened1]="panelOpenState1" [isPanelOpened2]="panelOpenState2"
        (saveTo)=saveToFav($event) (setToDefault)=setToDefault($event) [baristaInfo]="baristaInfo"
        (closePanels)=closePanels($event)></app-product-detail>
    </div>
  </div>
  <div class="product-desc">
    <div class="containerxx">
      <div class="row">
        <div class="col-12">
          <div class="mat-custom-pannel"
            [ngClass]="{'three-p': noOfpannel=='three','two-p':noOfpannel=='two','one-p': noOfpannel=='one'}">
            <mat-accordion class="example-headers-align" multi="false">
              <ng-container *ngIf= "selectedItem?.options && selectedItem?.options.customization && selectedItem?.options.customization.modifiersItems.length != 0">
                 <mat-expansion-panel [expanded]="panelOpenState == true" (opened)="panelOpenState = true" (closed)="panelOpenState = false" hideToggle="true"
                 >
                   <mat-expansion-panel-header class="container">
                     <mat-panel-title>
                     <span class="deafult"> {{selectedItem?.options.customization.title | uppercase}} <span class="deafult2" *ngIf= "isdefault"> (Default)</span></span>
                      <div class="main" >
                        <div class="innerCat" *ngFor= "let category of selectedItem?.options.customization.modifiersItems;let index=index;let isLast=last;" [attr.id]="'cat-item-id-'+index">
                          <div *ngFor = "let item of category.items">
                           <span *ngIf= "item['click']"> {{item.name | commaSeprated}} </span>
                          </div>
                        </div>
                        <span class="displayCatItem" *ngIf="showWithoutComma == true">{{catItem}}</span>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="container">
                    <hr>
                    <div class="row">
                      <div class="col-12">
                        <div class="listed-item">
                          <div
                            *ngFor="let category of selectedItem?.options.customization.modifiersItems;let i = index;let isLast=last">
                            <div class="item-details" [ngClass]="{'no-border-btm': isLast}">
                              <div class="list2">
                                <div class="title">
                                  <div class="left-text">
                                    <h4>{{ category.name | uppercase }}</h4>
                                  </div>
                                  <div class="right-text">
                                    <h6 *ngIf="category.selectionCriteria === 1">Select any one</h6>
                                    <h6 *ngIf="category.selectionCriteria > 1">Select up to
                                      {{category.selectionCriteria}}</h6>
                                  </div>
                                </div>
                              </div>
                              <div class="item_scroll">
                                <div class="d-flex" style="margin-bottom: 25px;">
                                  <div  *ngFor= "let item of category.items;let j = index">
                                  <button class="item_btn" *ngIf="item.inStock">
                                   <ng-container >
                                    <div class="item">
                                      <div class="product-img">
                                        <span *ngIf="category.name === 'Size'">
                                          <img src="assets/icon/coffe-tsb-selectd.svg" alt="coffe-starbucks"
                                            *ngIf="item['click']">
                                          <img src="assets/icon/tsb-coffe.png" alt="coffe-starbucks"
                                            *ngIf="!item['click']">
                                        </span>
                                      </div>
                                      <div class="select-btn">
                                        <button type="button"
                                          (click)="selectedCustProduct1(item,category.defaultItemIds[0],j,category,selectedItem.options.customization)"
                                          [ngClass]="{'selected': item['click'] }"
                                          class="button-outline default default2">{{item.name}}</button>
                                      </div>
                                      <div class="qty">
                                        <p *ngIf="item.basePrice === 0"><span
                                            *ngIf="item.description">{{item.description}}</span>
                                          <span *ngIf="item.description">-</span>
                                          <span *ngIf="!item.description">+</span>
                                          ₹ 0.00
                                        </p>
                                        <p *ngIf="item.basePrice != 0"> <span
                                            *ngIf="item.description">{{item.description}}</span>
                                          <span *ngIf="item.description">-</span>
                                          <span *ngIf="!item.description">+</span>
                                          ₹ {{item.basePrice | number}}
                                        </p>
                                      </div>
                                    </div>
                                  </ng-container>

                                  </button>
                                </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </ng-container>
              <ng-container *ngIf= "selectedItem?.options && selectedItem?.options.addons && selectedItem?.options.addons.modifiersItems.length != 0">
                <mat-expansion-panel [expanded]= "panelOpenState1 == true" (opened)= "setStep(1);panelOpenState1 = true" (closed)="panelOpenState1 = false" hideToggle="true">
                  <mat-expansion-panel-header class="container">
                    <mat-panel-title>
                      {{selectedItem?.options.addons.title | uppercase}}
                      <div class="main">
                        <div class="innerAdOn">
                          <div>
                            <span style="display:flex;"
                              *ngFor="let category of selectedItem?.options.addons.modifiersItems;let i=index;">
                              <span *ngFor="let item of category.items;let index = index;let isLast=last;">
                                <span *ngIf="item.selectedQty != 0">
                                  {{item.name | commaSeprated}}
                                </span>
                              </span>
                            </span>
                          </div>
                        </div>
                        <div class="inner" *ngIf="!showAdOnWithoutComma">
                          <div>
                            <span style="display:flex;"
                              *ngFor="let category of selectedItem?.options.addons.modifiersItems;let i=index;">
                              <span *ngFor="let item of category.items;let index = index;let isLast=last;">
                                <span *ngIf="!isPhone" class="desktop">
                                  <span *ngIf="item.selectedQty === 0">
                                    <span class="displayCatItem" *ngIf="i == 0 && index == 0"> {{selectedItem?.options.addons.description}}
                                    </span>
                                  </span>
                                </span>
                                <span *ngIf="isPhone" class="phone">
                                  <span *ngIf="panelOpenState1">
                                    <span *ngIf="item.selectedQty === 0">
                                      <span class="displayCatItem" *ngIf="i == 0 && index == 0"> {{selectedItem?.options.addons.description}}
                                      </span>
                                    </span>
                                  </span>
                                  <span *ngIf="!panelOpenState1">
                                    <span *ngIf="item.selectedQty === 0" class="d-flex">
                                      <span class="displayCatItem" *ngIf="i == 0 && index == 0"> {{selectedItem?.options.addons.description |
                                        slice:0:69}} </span>
                                      <span
                                        *ngIf="i == 0 && index == 0 && selectedItem?.options.addons.description.length>70">
                                        ...</span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </div>
                        </div>
                        <span class="displayCatItem" *ngIf="showAdOnWithoutComma">{{adOnItem}}</span>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="container">
                    <hr>
                    <div class="item-details"
                      *ngFor= "let category of selectedItem?.options.addons.modifiersItems;let index = index">
                      <div class="list">
                        <div class="title">
                          <div class="left-text">
                            <h4>{{ category.name | uppercase }}</h4>
                          </div>
                          <div class="right-text">
                            <h6 *ngIf="category.selectionCriteria === 1">Select any one</h6>
                            <h6 *ngIf="category.selectionCriteria > 1">Select up to {{category.selectionCriteria}}</h6>
                          </div>
                        </div>
                        <div *ngFor="let item of category.items;let ix = index;">
                        <div class="list-item d-flex" *ngIf="item.inStock">
                          <ng-container>
                          <div class="item-name no-margin">
                            <h5>{{item.name}}</h5>
                            <p class="f-10" *ngIf="item.basePrice != 0">+ ₹ {{item.basePrice}}</p>
                          </div>
                          <div class="selection">
                            <span class="circle minus" (click)="decrement(item,ix)"></span>
                            <span class="counter gg">{{item.selectedQty}}</span>
                            <span class="circle plus" (click)="increment(item,ix,category)"></span>
                          </div>
                        </ng-container>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </ng-container>
              <ng-container *ngIf= "selectedItem?.options && selectedItem?.options.condiments && selectedItem?.options.condiments.modifiersItems.length != 0">
                <mat-expansion-panel [expanded]= "panelOpenState2 == true" (opened)= "setStep(2);panelOpenState2 = true" (closed)="panelOpenState2 = false" hideToggle="true">
                  <mat-expansion-panel-header class="container">
                    <mat-panel-title>
                      {{selectedItem?.options.condiments.title | uppercase}}
                      <div class="main">
                        <div class="inner">
                          <div>
                            <span style="display:flex;"
                              *ngFor="let category of selectedItem?.options.condiments.modifiersItems">
                              <span *ngFor="let item of category.items;let index = index">
                                <span *ngIf="item.selectedQty != 0;">
                                  {{item.name | commaSeprated}}
                                </span>
                                <span *ngIf="item.selectedQty === 0;">
                                  <span *ngIf="index === 0"> {{selectedItem?.options.condiments.description}} </span>
                                </span>
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="container">
                    <hr>
                    <div class="item-details"
                      *ngFor="let category of selectedItem?.options.condiments.modifiersItems;let index = index">
                      <div class="list">
                        <div class="title">
                          <div class="left-text">
                            <h4>{{category.name}}</h4>
                          </div>
                          <div class="right-text">
                            <h6 *ngIf="category.selectionCriteria === 1">Select any one</h6>
                            <h6 *ngIf="category.selectionCriteria > 1">Select up to {{category.selectionCriteria}}</h6>
                          </div>
                        </div>
                        <div *ngFor= "let item of category.items;let ix = index;">
                        <div class="list-item d-flex" *ngIf="item.inStock">
                          <ng-container>
                          <div class="item-name no-margin">
                            <p>{{item.name}}</p>
                            <p class="f-10" *ngIf="item.basePrice != 0">+ ₹ {{item.basePrice}}</p>
                          </div>
                          <div class="selection">
                            <span class="circle minus" (click)="decrementCond(item,ix)"></span>
                            <span class="counter gg">{{item.selectedQty}}</span>
                            <span class="circle plus" (click)="incrementCond(item,ix,category)"></span>
                          </div>
                          </ng-container>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </mat-expansion-panel>
              </ng-container>
            </mat-accordion>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="price-details radius-10 fixed-bottom-footer2">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-8">
          <div class="item-and-price">
            <div *ngIf="isPhone">
              <h5>CURRENT ITEM</h5>
              <p>{{selectedItem.name | slice:0:20}}
                <span *ngIf="selectedItem.name.length>20"> ...</span>
              </p>
            </div>
            <div *ngIf="!isPhone">
              <h5>CURRENT ITEM</h5>
              <p>{{selectedItem.name | titlecase}}
              </p>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="item-and-price" style="
          justify-content: flex-end;
      ">
            <div>
              <h4>₹ {{selectedItem.defaultPrice | priceformat:'integer' }}<span
                  class="round-figure">.{{selectedItem.defaultPrice | priceformat:'decimal'}}</span></h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="add-to-cart fixed-bottom-footer">
    <div class="container">
      <div class="row">
        <div class="col-12 text-right" [ngClass]="{'shimmer-loader-button': isClicked}">
          <button type="button" [disabled]= "addItemEvent || selectedItem.inStock=== false" class="add-cart-btn" (click)="addtoCart(selectedItem)"
            [ngClass]="{'br animate-button-white' : isClicked,'grey-btn':selectedItem.inStock=== false}">  {{selectedItem.inStock=== false ? 'Out of Stock':'Add Item'}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
